// 認証画面共通レイアウト(login / signup)
// 設計書 ui-mockups/screens/performer-login-pc.html 準拠の中央寄せフレーム

import type { ReactNode } from 'react';
import { Logo } from './ui/Logo';

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-bg)',
        padding: '32px 16px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 360,
          background: 'var(--color-card-strong)',
          border: 'var(--border-default)',
          borderRadius: 'var(--radius-lg)',
          padding: '32px 28px',
        }}
      >
        <div style={{ marginBottom: '28px', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <Logo />
          </div>
          <h1
            style={{
              fontSize: '18px',
              fontWeight: 500,
              color: 'var(--color-text-primary)',
              margin: '0 0 6px',
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              style={{
                fontSize: '11px',
                color: 'var(--color-text-secondary)',
                margin: 0,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
        {children}
        {footer && (
          <div
            style={{
              marginTop: '20px',
              paddingTop: '16px',
              borderTop: 'var(--border-default)',
              fontSize: '11px',
              color: 'var(--color-text-secondary)',
              textAlign: 'center',
            }}
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
